var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-zip)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11382 0H14.1229L20.91 7.09007V20.8792C20.91 22.5982 19.5114 24 17.7962 24H6.11382C4.39128 24 3 22.5982 3 20.8792V3.12081C3 1.39441 4.39128 0 6.11382 0Z",
    fill: "#FFB11F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1155 0V7.03105H20.9099L14.1155 0Z",
    fill: "white",
    fillOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59571 12.4678V10.8299C9.59571 10.6528 9.45584 10.5127 9.27917 10.5127H8.39582C8.21915 10.5127 8.07928 10.6528 8.07928 10.8299V12.4678L7.58608 13.9138C7.44621 14.3196 7.51246 14.7697 7.76275 15.1164C8.00567 15.4632 8.41054 15.6697 8.8375 15.6697C9.26445 15.6697 9.66196 15.4632 9.91224 15.1164C10.1625 14.7697 10.2288 14.3196 10.0889 13.9138L9.59571 12.4678ZM9.38959 14.7401C9.13931 15.1017 8.53568 15.1017 8.27804 14.7401C8.1529 14.5631 8.11609 14.327 8.1897 14.1204L8.35165 13.6335H9.31598L9.48529 14.1204C9.55154 14.327 9.5221 14.5631 9.38959 14.7401ZM6.87939 1.71832V2.61841C6.87939 2.79547 7.01926 2.93565 7.19593 2.93565H8.39582V4.27841H7.19593C7.01926 4.27841 6.87939 4.41859 6.87939 4.59566V5.28917C6.87939 5.46624 7.01926 5.6138 7.19593 5.6138H8.39582V6.94918H7.19593C7.01926 6.94918 6.87939 7.08936 6.87939 7.26643V7.96732C6.87939 8.14438 7.01926 8.28456 7.19593 8.28456H8.39582V9.3027C8.39582 9.47977 8.54304 9.61995 8.71972 9.61995H10.4791C10.6484 9.61995 10.7956 9.47977 10.7956 9.3027V8.60181C10.7956 8.43212 10.6484 8.28456 10.4791 8.28456H9.27181V6.94918H10.4791C10.6484 6.94918 10.7956 6.809 10.7956 6.63193V5.93104C10.7956 5.75398 10.6484 5.6138 10.4791 5.6138H9.27181V4.27841H10.4791C10.6484 4.27841 10.7956 4.13086 10.7956 3.95379V3.26028C10.7956 3.08321 10.6484 2.93565 10.4791 2.93565H9.27181V1.71094L6.87939 1.71832Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-zip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.21a5a3cceee4267e02ede21316d1f6e3.svg";
export { ForwardRef as ReactComponent };